import InputFilterTableColumns from './InputFilterTableColumns';

export default InputFilterTableColumns;
